import { Injectable } from '@angular/core';

@Injectable()
export class RecaptchaTokenService {

    constructor() { }

    public getRecaptchaToken(): string {
        const challenge = (<HTMLInputElement>document.getElementById('g-recaptcha-response'));

        if (challenge == null) { return null; }

        return challenge.value;

    }

}



// WEBPACK FOOTER //
// ./src/app/services/recaptcha-token.service.ts